import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsService {

  private googleLoaded = false;

  constructor() {
    // Don't automatically load Google Maps here since it's already loaded in index.html
  }

  private loadGoogleMaps(): Promise<void> {
    return new Promise((resolve, reject) => {
      // Check if Google Maps is already loaded from index.html
      if (typeof google !== 'undefined' && google.maps) {
        this.googleLoaded = true;
        resolve();
        return;
      }

      if (this.googleLoaded) {
        resolve();
        return;
      }

      // Only load if not already present
      const script = document.createElement('script');
      script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDrl29BNQVeFv93cfa5N6lf2lZ8Bxof2A4&libraries=places&loading=async';
      script.onload = () => {
        this.googleLoaded = true;
        resolve();
      };
      script.onerror = (error) => {
        reject('Google Maps API could not be loaded.');
      };

      document.head.appendChild(script);
    });
  }

  public geocodeAddress(location: string): Promise<any> {

    return this.loadGoogleMaps().then(() => {
      return new Promise((resolve, reject) => {
        // Add a small delay to ensure Google Maps is fully initialized
        setTimeout(() => {
          try {
            // Double-check that Google Maps is available
            if (typeof google === 'undefined' || !google.maps) {
              console.warn('Google Maps not available, retrying...');
              setTimeout(() => {
                this.geocodeAddress(location).then(resolve).catch(reject);
              }, 500);
              return;
            }

            const geocoder = new google.maps.Geocoder();

            geocoder.geocode({ address: location }, (results, status) => {
              if (status === google.maps.GeocoderStatus.OK && results[0]) {
                const components = results[0].address_components;
                const geometry = results[0].geometry.location;
                const locationDetails: any = {

                };

                const addressParts = {

                  lat: geometry.lat(),  // Get latitude
                  lng: geometry.lng(),  // Get longitude

                  full_address: results[0].formatted_address, // Full address

                  landMark: components.filter((item: any) => {
                    if (item.types[2] == 'sublocality_level_1')
                      return item
                  })[0]?.long_name || '',

                  city: components.filter((item: any) => {
                    if (item.types[0] == 'administrative_area_level_2')
                      return item
                  })[0]?.long_name || '',

                  state: components.filter((item: any) => {
                    if (item.types[0] == 'administrative_area_level_1')
                      return item
                  })[0]?.long_name || '',

                  country: components.filter((item: any) => {
                    if (item.types[0] == "country")
                      return item
                  })[0]?.long_name || '',

                  zipcode: components.filter((item: any) => {
                    if (item.types[0] == "postal_code")
                      return item
                  })[0]?.long_name || '',

                  locality: components.filter((item: any) => {
                    if (item.types[0] == "locality")
                      return item
                  })[0]?.long_name || '',

                }
                console.log("addressParts", addressParts);

                resolve(addressParts);
              } else {
                // resolve({city: "", country: "",full_address : "", landMark : "", lat : "", lng : "", locality : "", state : "", zipcode : ""})
                resolve(null)
                // reject('Geocoding failed: ' + status);
              }
            });
          } catch (error) {
            console.error('Error in geocoding:', error);
            resolve(null);
          }
        }, 200);
      });
    });
  }

}
